<template>
  <div class="receive-coupon">
    <van-popup v-model="showPopup" :class="{move:showSelect}" class="popup">
      <div v-if="serialList.length===1" class="big-title">是否领取该车系优惠券</div>
      <div v-else class="big-title">选择您的意向车系</div>
      <div class="popup-content">
        <div @click="showSelectFn" :class="{'bg-none':serialList.length===1}" class="select">{{serial.name}}</div>
        <div @click="receiveCoupon" class="btn">立即领取</div>
        <van-checkbox v-show="isShow" v-model="checked" checked-color="#cccccc" :label-disabled="true">
          <span @click="gotoAgreement" class="agreement-tips">我已阅读并同意隐私政策</span>
        </van-checkbox>
      </div>
      <div @click="showPopup=false" class="close"></div>
    </van-popup>
    <van-popup v-model="showSelect" position="bottom" :overlay="false">
      <van-picker
        ref="picker"
        :columns="serialList"
        value-key="name"
        :show-toolbar="true"
        cancel-button-text=" "
        @confirm="receiveCoupon"
        @change="selectChange">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { getActivitySerialList, receiveCoupon } from 'common/js/api'

export default {
  name: 'receive-coupon',
  data() {
    return {
      showPopup: false,
      showSelect: false,
      coupon: {},
      serial: {},
      noSerial: { name: '请选择意向车系' },
      serialList: [],
      mid: '',
      isShow: false,
      checked: true
    }
  },
  watch: {
    showPopup(val) {
      if (!val) {
        this.showSelect = false
      }
    }
  },
  methods: {
    clickCoupon(coupon, mid) {
      this.coupon = coupon
      this.mid = mid
      const couponCount = this.$storejs.get(`${this.$key}CouponCount`) || 0
      if (this.coupon.is_client === 1) {
        this.$toast('请勿重复领取')
      } else if (couponCount >= 3) {
        this.$toast('最多领取3张优惠券')
      } else {
        this.getSerialList()
      }
    },
    async getSerialList() {
      const res = await getActivitySerialList.call(this, this.$key, this.coupon.id)
      if (res.code === 0) {
        if (res.data.list.length === 1) {
          this.serial = res.data.list[0]
          this.serialList = res.data.list
        } else {
          this.serial = this.noSerial
          this.serialList = [...[this.noSerial], ...res.data.list]
        }
        this.isShow = res.data.isShow
        this.showPopup = true
      } else {
        this.$toast(res.msg)
      }
    },
    showSelectFn() {
      this.showSelect = true
      this.$nextTick(() => {
        this.$refs.picker.setIndexes([0])
      })
    },
    selectChange(vm, val) {
      this.serial = val
    },
    async receiveCoupon() {
      if (this.isShow && !this.checked) {
        this.$toast('需勾选须知说明才能领优惠券哦~')
        return
      }
      if (!this.serial.id) {
        this.$toast('车系不能为空')
        return
      }
      const res = await receiveCoupon.call(this, {
        baseURL: this.$baseURL.cat,
        url: '/shcz190329/new/coupon/receive',
        data: {
          uid: this.$state.uid,
          coupon: this.coupon,
          serial: this.serial,
          city: this.$state.city
        },
        params: {
          mid: this.mid
        }
      })
      if (res.success === true) {
        // 领取成功，置灰
        this.showPopup = false
        this.$toast('领取成功，请到支付宝卡包查看')
        this.coupon.is_client = 1
        // 限制领取优惠券
        const couponCount = this.$storejs.get(`${this.$key}CouponCount`) || 0
        this.$storejs.set(`${this.$key}CouponCount`, couponCount + 1)
      } else {
        this.$toast(res.error_msg)
      }
    },
    gotoAgreement() {
      const url = `https://cat.pangku.com/static/agreement/index.html`
      ap.pushWindow(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-content {
  height: 370px;
  .btn {
    margin-top: 10px;
  }
}
.agreement-tips {
  color: #cccccc;
}
</style>
